import NetAxios from './api'

export const limit = 20;
export class HttpServer {
    static account: string | null;


    /**
     *  登陆接口
     * @param sigHex
     * @param msg
     */
    static login(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/login', {user_id:this.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }


    /**
     *  查询仲裁数
     * @param sigHex
     * @param msg
     */
    static arbiter(): Promise<any> {
        return NetAxios.get('/api/arbiter', {userId:HttpServer.account});
    }

    /**
     *  登陆接口
     * @param sigHex
     * @param msg
     */
    static claim(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/claim', {user_id:this.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }



    /**
     *  申请成为仲裁者
     * @param sigHex
     * @param msg
     */
    static addArbiter(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/addArbiter', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }


    /**
     *  减少仲裁资格
     * @param sigHex
     * @param msg
     */
    static pending(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/pending', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }

    /**
     *  理赔仲裁申请
     * @param sigHex
     * @param msg
     */
    static claimApply(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/claimApply', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }

    /**
     *  领取奖励
     * @param sigHex
     * @param msg
     */
    static withdraw(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/withdraw', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }


    /**
     *  理赔仲裁申请查询
     */
    static claimListNew(before:number): Promise<any> {
        return NetAxios.get('/api/claimListNew', {userId:HttpServer.account,before:(before - 1) *limit,after:before * limit});
    }

    /**
     *  管理员理赔仲裁申请查询
     */
    static claimListAdmin(url:string): Promise<any> {
        return NetAxios.get('/api/'+url, {userId:HttpServer.account,});
    }


    /**
     *  理赔仲裁申请查询
     */
    static claimListDown(before:number): Promise<any> {
        return NetAxios.get('/api/claimListDown', {userId:HttpServer.account,before:(before - 1) *limit,after:before * limit});
    }

    /**
     *  资产历史查询
     */
    static asset(before:number): Promise<any> {
        return NetAxios.get('/api/asset', {userId:HttpServer.account, before:(before - 1) *limit,after:before * limit});
    }


    static assessment(claimId:number): Promise<any> {
        return NetAxios.get('/api/assessment', {claimId});
    }


    static assessmentP(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/assessment', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }

    /**
     * 管理员 assessment
     * @param sigHex
     * @param msg
     */
    static assessmentAdmin(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/assessmentAdmin', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }

    // 第一轮投票后的查询
    static assessmentResult(claimId: string,): Promise<any> {
        return NetAxios.get('/api/assessmentResult', {claimId});
    }

    // 大约抵押保费金额等值的
    static challenge(claimId: string,): Promise<any> {
        return NetAxios.get('/api/challenge', {userId:HttpServer.account, claimId});
    }

    // 发起挑战
    static challengeP(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/challenge', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }

    /**
     * 管理员设置挑战结果
     * @param sigHex
     * @param msg
     */
    static challengeResult(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/challengeResult', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }

    /**
     * claimPay
     * @param sigHex
     * @param msg
     */
    static claimPay(sigHex: string, msg: string,): Promise<any> {
        return NetAxios.post('/api/claimPay', {user_id:HttpServer.account, sig_hex:sigHex, msg:JSON.parse(msg),});
    }


}
